<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    // The ID of the modal to use with v-b-modal.the-id
    modalId: {
      type: String,
      default: "leave-team-modal",
    },
  },

  computed: {
    // Mapped vuex state
    ...mapGetters(["activeTeam"]),
  },

  methods: {
    // Leave the team and hide the modal
    async leave() {
      await this.leaveTeam();
      this.hide();
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["leaveTeam"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Leave Team"
    button-size="sm"
    hide-header-close
  >
    <p>
      Are you sure you would like to leave the
      <b>#{{ activeTeam.handle }}</b>
      team?
    </p>
    <p>
      If you change your mind, another member of the team will have to reinvite
      you.
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="danger" @click="leave">Leave Team</b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
